import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TrustHtmlPipe } from '@pipes';
import { GTMService } from '@services';
import { AuthStore, Helpers, ServiceTicketCallback, ServiceTicketStore } from '@store';

import { ViNotificationComponent } from '../../../../projects/ui/components/notification/notification.component';
import { GtmDirective } from '../../directives/gtm/gtm.directive';

@Component({
  selector: 'app-callback-notification',
  standalone: true,
  imports: [CommonModule, GtmDirective, TranslateModule, ViNotificationComponent, TrustHtmlPipe],
  templateUrl: './callback-notification.component.html',
  styleUrls: ['./callback-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('notification', [transition('* => void', [animate(200, style({ height: 0 }))])]),
  ],
})
export class CallbackNotificationComponent {
  constructor(
    public serviceTicketStore: ServiceTicketStore,
    public authStore: AuthStore,
    private gtmService: GTMService
  ) {}

  onClose(cb: ServiceTicketCallback): void {
    this.serviceTicketStore.removeCachedCallback(cb.id);
    this.gtmService.track('onClose', 'Service App callback bar', 'notification');
  }

  areWorkingHours(time: string): 'yes' | 'after' | 'before' {
    if (Helpers.isCallbackTimeWithinWorkingHours(time, Helpers.callbackTimeDefaultConfig)) {
      return 'yes';
    }

    return +time.substring(0, 2) < 7 ? 'before' : 'after';
  }
}
